/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React from 'react';
import { CONTENT_TYPE } from '../../../constants/globalConstants';
import { buildImgUrl, getSponsorData, getStatsBarData } from '../../../utils/utils';
import ImageFallback from '../../Common/ImageFallback';
import Modal from '../../Common/Modal';
import Sponsor from '../../Common/Sponsor';
import StatsBar from '../../Common/StatsBar';
import { IMAGE_MODAL } from '../../../constants/containerConstants';
import UpSell from '../../Common/UpSell';

const ImageModal = (props) => {
  const { closeModal, imageData, itemid, isDestinationPage, onClose } = props;
  const imageCrops =
    imageData &&
    imageData['Image File'] &&
    imageData['Image File'].value &&
    imageData['Image File'].value.Crops &&
    imageData['Image File'].value.Crops.img1x;
  const imageAltText =
    imageData &&
    imageData['Image File'] &&
    imageData['Image File'].value &&
    imageData['Image File'].value.AltText;
  const sponsorInfo = imageData.Sponsorby && getSponsorData(imageData.Sponsorby.fields);

  const createImgUrl = (relativePath) => {
    if (relativePath && typeof relativePath == 'object') {
      relativePath = relativePath.img1x;
    }
    return buildImgUrl(relativePath);
  };

  const renderHeaders = () => {
    return (
      <Sponsor
        contentType={imageData.ContentType && imageData.ContentType.value}
        varient={imageData.Variant && imageData.Variant.value}
        sponsorInfo={sponsorInfo}
        grid={'grid-12'}
        type={CONTENT_TYPE}
        cardName={imageData.Teaser && imageData.Teaser.value}
        container={IMAGE_MODAL}
        createdDateTime={imageData.__Published && imageData.__Published.value}
        itemId={itemid}
        tags={imageData.manutds && imageData.manutds.value && imageData.manutds.value.Tags}
      />
    );
  };

  const renderFooter = () => {
    return (
      <React.Fragment>
        <StatsBar
          item={getStatsBarData(imageData)}
          noTags={true}
          upSellData={imageData.UpsellMapping}
        />
      </React.Fragment>
    );
  };

  return (
    <Modal
      headerChildren={renderHeaders()}
      closeModal={closeModal}
      onClose={isDestinationPage && onClose}
      footerChildren={renderFooter()}
      modalType="image-modal"
    >
      <div className="mu-modal__body__container singleimg">
        <div className="image-card">
          <img
            src={createImgUrl(imageCrops)}
            id="img-hammer"
            alt={imageAltText}
            className="gallery-img"
          />
          <div
            className="gallery-img__bg"
            style={{ background: `url(${createImgUrl(imageCrops)})` }}
            alt=""
          >
            <ImageFallback
              className="img-responsive visually-hidden"
              src={imageCrops}
              alt={imageAltText}
              onErrorClass="no-img"
            />
          </div>
          <div className="mu-item__gradient"></div>
        </div>
        <div className="mu-modal__body__description">
          <div className="mu-item__teasure">{imageData.Teaser && imageData.Teaser.value}</div>
          {imageData.UpsellMapping && <UpSell data={imageData.UpsellMapping} />}
        </div>
      </div>
    </Modal>
  );
};

export default ImageModal;
